import { ErrorHandler, Injectable, Inject } from '@angular/core';
import { SessionService } from '@hub-components';
import { RollbarServiceToken } from './rollbar.config';
import * as Rollbar from 'rollbar';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  private alreadyTracked = {}

  constructor(
    @Inject(RollbarServiceToken) private rollbar: Rollbar,
    private session: SessionService
  ) {}

  handleError(err: any): void {
    const error = err.originalError || err
    const message = err.message
    if (message && !this.alreadyTracked[message]) {
      const env = this.session.env
      const user = this.session.user
      const account = this.session.account
      if (env && user && account) {
        this.rollbar.configure({
          payload: {
            environment: env,
            email: user.email,
            account: account.name,
            person: { id: user.email }
          }
        });
      }

      console.error(...this.sanitizedError(error));
      this.rollbar.error(...this.sanitizedError(error));
      this.alreadyTracked[message] = true
    }
  }

  private sanitizedError(error: any) {
    if (error instanceof Error || error instanceof String) {
      return [error];
    } else if (error instanceof HttpErrorResponse) {
      return [error.message, error];
    } else {
      return ['Error', error];
    }
  }
}

export const ROLLBAR_ERROR_HANDLER = {
  provide: ErrorHandler, useClass: RollbarErrorHandler
}
